import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { UserStatsProvider } from './context/UserStatsContext';
import { SubscriptionProvider } from './context/SubscriptionContext';
import { ThemeProvider } from './context/ThemeContext';
import ErrorBoundary from './components/ErrorBoundary';
import { setupGlobalErrorHandlers } from './services/setupErrorHandlers';
import reportWebVitals from './reportWebVitals';

// Redirect from old domain to new domain
if (window.location.hostname === 'pronunciation-ui.vercel.app') {
  window.location.replace(`https://litrlly.app${window.location.pathname}${window.location.search}`);
}

// Setup global error handlers
setupGlobalErrorHandlers();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <ErrorBoundary>
    <ThemeProvider>
      <AuthProvider>
        <SubscriptionProvider>
          <UserStatsProvider>
            <App />
          </UserStatsProvider>
        </SubscriptionProvider>
      </AuthProvider>
    </ThemeProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
